import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { AbstractJobService } from '../../api/job.service';

@UntilDestroy()
@Component({
  selector: 'y42-refresh-jobs-button',
  templateUrl: './refresh-jobs-button.component.html',
  styleUrls: ['./refresh-jobs-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshJobsButtonComponent {
  constructor(private readonly service: AbstractJobService) {}

  readonly state = connectState(this, {
    isLoading: this.service.loading$,
  });

  refreshJobs() {
    this.service.refreshJobs({ force: true });
  }
}
